<template>
    <div class="mt-15">
                <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="8">
                        <span>Selecciona Producto</span>
                        <v-btn v-if="opc!='Nuevo'" @click="d_producto=true" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                        <v-btn v-else class="ml-5" x-small color="grey" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="mt-n5">
                        <v-radio-group v-model="opc" row>
                        <v-radio @click="clsInput()" label="Nuevo" value="Nuevo"></v-radio>
                        <v-radio @click="clsInput()" label="Modificar" value="Modificar"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row class="mt-7">
                    <v-col cols="12" md="2" class="mt-n7">
                        <v-text-field label="Sku" maxlength="10" class='text-body-2' v-model="sku" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5" class="mt-n7">
                        <v-text-field label="Nombre" class='text-body-2' v-model="producto" dense outlined rounded></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="12" md="3" class="mt-n7">
                        <v-text-field label="Marca" class='text-body-2' v-model="marca" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="mt-n7">
                        <v-text-field label="Caracteristica" class='text-body-2' v-model="caracteristica" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="7" md="3" class="mt-n7">
                        <v-select class='text-caption' v-model="categoria" :items="categorias" label="Categoria" dense outlined rounded></v-select>
                    </v-col>
                    <v-col cols="5" md="2" class="mt-n7">
                        <v-btn @click="open_category()" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>add</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="5" md="2" class="mt-n7">
                        <v-text-field type="number" label="Precio" class='text-body-2' v-model="precio" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="4" md="2" class="mt-n7">
                        <v-select class='text-caption' v-model="estado" :items="estados" label="Estado" dense outlined rounded></v-select>
                    </v-col>
                </v-row>
                <v-row class="mt-n10">
                    <v-col cols="12" md="6"></v-col>
                    <v-col cols="6" md="3" class="text-end">
                        <v-btn @click="clsInput()" small color="teal" dark rounded block><span class="text-caption">Limpiar</span></v-btn>
                    </v-col>
                    <v-col cols="6" md="3" class="text-end">
                        <v-btn v-if="opc!='Nuevo'" @click="update_producto()" small color="teal" dark rounded block><span class="text-caption">Modificar</span></v-btn>
                        <v-btn v-else @click="save_producto()" small color="teal" dark rounded block><span class="text-caption">Grabar</span></v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
            <div style="height: 50px;"></div>
            <v-footer height="50" color="#c1680e" fixed></v-footer>

        <v-dialog v-model="d_producto" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Productos
                    <v-spacer></v-spacer>
                    <v-icon @click="d_producto=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Rut</th>
                                    <th style="background-color: lightgrey;">Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handProducts(item)" v-for="item in myProducts" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Sku }}</span></td>
                                    <td><span class="text-body-2">{{ item.Producto }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>


        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>

        <!-- dialog categoria --> 
        <v-dialog v-model="d_category" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_category=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                <strong class="ml-5 text-body-2">CATEGORIAS</strong>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-7">
                    <v-col cols="12" md="6" class="mt-n7">
                        <v-text-field class='text-body-2' v-model="category" label="Nueva Categoria" outlined dense rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="mt-n7">
                        <v-btn @click="save_category()" class="mt-1" small color="teal" dark rounded>ingresar</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<script>
import axios from "axios";
export default {
    name: 'Productos',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        opc:'Nuevo',

        id_producto:0,
        sku:'',
        producto:'',
        marca:'',
        caracteristica:'',
        categoria:'',
        precio:'',
        estado:'V',
        d_producto:false,
        estados:['V','N'],
        categorias:[],
        myProducts:[],
        d_category:false,
        category:'',

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(9);
            if(parseInt(this.bloqueo)!=0){
                await this.search_productos();
                await this.search_categorias();
            };
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        clsInput(){
            this.id_producto=0,
            this.sku='';
            this.producto='';
            this.marca='';
            this.caracteristica='';
            this.precio='';
            this.categoria='';
            this.estado='V';
        },
        async search_productos(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'products' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/products/',params,{headers});
                const datos = res.data;
                console.log('productos',datos);
                if(datos[0].existe=='si'){
                    this.myProducts = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_categorias(){
            this.categorias=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'category' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/category/',params,{headers});
                const datos = res.data;
                console.log('categorias',datos);
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.categorias.push(element.Categoria)
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        handProducts(item){
            console.log(item)
            this.id_producto=item.ID;
            this.sku=item.Sku;
            this.producto=item.Producto;
            this.marca=item.Marca;
            this.caracteristica=item.Caracteristica;
            this.categoria=item.Categoria;
            this.precio=item.Precio;
            this.estado=item.Estado;
            this.d_producto=false
        },
        async exists_products(){
            let result = false;
            const filter = this.myProducts.filter(res => res.Sku == this.sku);
            if(filter.length!=0){ result = true };
            return result
        },
        async save_producto(){
            this.loading=true;
            if(this.sku!=null && this.sku!='' && this.producto!=null && this.producto!=''){
                const exists = await this.exists_products();
                if(!exists){
                    let price = 0;
                    if(this.precio!=null){
                        if(this.precio!=''){
                            price = parseFloat(this.precio);
                        }
                    };
                    try {
                        const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Token ' + this.apikey
                        };
                        const params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'sku':this.sku,
                            'producto':this.producto,
                            'marca':this.marca,
                            'caracteristica':this.caracteristica,
                            'categoria':this.categoria,
                            'precio':price,
                            'estado':this.estado
                        };
                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/products/',params,{headers});
                        const datos = res.data;
                        if(datos[0].existe=='si'){
                            await this.search_productos();
                            this.color_snack='success';
                            this.mensaje='Producto ingresado con exito';
                            this.snack=true
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Producto ingresado ya existe';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos del producto';
                this.snack=true
            };
            this.loading=false;
        },
        async update_producto(){
            this.loading=true;
            if(this.sku!=null && this.sku!='' && this.producto!=null && this.producto!=''){
                let price = 0;
                if(this.precio!=null){
                    if(this.precio!=''){
                        price = parseFloat(this.precio);
                    }
                };
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' : this.user,
                        'id': this.id_producto,
                        'sku':this.sku,
                        'producto':this.producto,
                        'marca':this.marca,
                        'caracteristica':this.caracteristica,
                        'categoria':this.categoria,
                        'precio':price,
                        'estado':this.estado
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/products/',params,{headers});
                    const datos = res.data;
                    console.log('update producto', datos)
                    if(datos[0].existe=='si'){
                        await this.search_productos();
                        this.color_snack='success';
                        this.mensaje='Producto modificado con exito';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos del producto';
                this.snack=true
            };
            this.loading=false;
        },
        open_category(){
            this.category='';
            this.d_category=true;
        },
        async save_category(){
            if(this.category!=null && this.category!=''){
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' : this.user,
                        'categoria': this.category,
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/category/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.search_categorias();
                        this.categoria=this.category;
                        this.d_category=false;
                    }                    
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese nueva categoria';
                this.snack=true
            }
        }
        
    }
}
</script>
